import * as React from 'react';
import { BookingView } from 'cb-model';
import {
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useCloneEntity,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { ReportMenu } from './ReportMenu';

export const BookingSearch = (): React.JSX.Element => {
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(BookingView);
  const LocalBookingView = useCloneEntity(BookingView, (clone) => {
    clone.fields.user_id.listColumn = true;
  });
  const gCacheQueryItem = useCacheQuery(BookingView, queryOptions);

  return (
    <>
      <PageTitle title="Booking Detail Report" />
      <ReportMenu />
      <Section>
        <p>Attendance per Booking</p>
        <PaginatorAndListSettings
          entity={LocalBookingView}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
